export class PaginationModel {
  constructor(
    public content: any[] = [],
    public pageable: Pageable = new Pageable(),
    public totalElements: number = 0,
    public totalPages: number = 0,
    public last: boolean = false,
    public size: number = 0,
    public number: number = 0,
    public sort: object = new Sort(),
    public first: boolean = false,
    public numberOfElements: number = 0,
    public empty: boolean = false,
  ) {
    this.content = content;
    this.pageable = pageable;
    this.totalElements = totalElements;
    this.totalPages = totalPages;
    this.last = last;
    this.size = size;
    this.number = number;
    this.sort = sort;
    this.first = first;
    this.numberOfElements = numberOfElements;
    this.empty = empty;
  }
}

class Pageable {
  constructor(
    public sort: Sort = new Sort(),
    public offset: number = 0,
    public pageNumber: number = 0,
    public pageSize: number = 0,
    public paged: boolean = false,
    public unpaged: boolean = false,
  ) {}
}

class Sort {
  constructor(
    public empty: boolean = false,
    public sorted: boolean = false,
    public unsorted: boolean = false,
  ) {}
}
